export const arrowMenuClose = `<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.2498 16V0L22 0V16H19.2498ZM5.49897 6.66667L8.93806 3.33333L6.87543 1.33333L0 8L6.87543 14.6667L8.93806 12.6667L5.50034 9.33333H16.501V6.66667H5.49897Z" fill="white"/>
</svg>
`;